// Wrapper de API do provisionamento de acesso SFTP da transportadora (épico PO1-2160,
// tela PO1-2167). Backend: backend_hub, módulo sftp-acesso. Todas as rotas são admin
// Everlog. Mesmo padrão de onboardingApi.js: devolve `data`; o erro é lido de
// err.response.data (error = código, mensagem = texto).

import api from "./api";

export async function previewAcessoSftp({ embarcadorId, cnpj }) {
  const { data } = await api.get("/sftp-acesso/preview", { params: { embarcadorId, cnpj } });
  return data;
}

// payload: { embarcadorId, cnpj | idTransportadora, fantasia?, confirmarApelido?, religarVinculo?,
//            modoAuth, chaves?: [{ nome, chavePublica }], email,
//            contatos?: { ti: { nome, email, telefone }, logistica?, cotacao? } }  (PO1-3282)
// Com a entrada única ligada a resposta é a do Onboarding de Transportadora:
// { ok, estado ('OPERACIONAL'|'EM_ONBOARDING'|'AGUARDANDO_HOMOLOGACAO'|'EM_CURADORIA'),
//   idTransportadora, passos: [{ passo, status, detalhe }], curadoria?, emAndamento? }.
// `status` HTTP vai junto porque a curadoria pode vir como 202.
export async function provisionarAcessoSftp(payload) {
  const res = await api.post("/sftp-acesso/provisionar", payload);
  return Object.assign({}, res.data, { httpStatus: res.status });
}

// Acessos já registrados do embarcador, para achar um acesso pelo nome em vez de
// precisar saber o CNPJ. Só banco, não consulta o Wing, e nunca traz senha: cada
// item diz apenas se existe uma guardada (`temSenha`).
export async function listarAcessosSftp(embarcadorId) {
  const { data } = await api.get("/sftp-acesso/acessos", { params: { embarcadorId } });
  return data;
}

export async function getAcessoSftp(idEmbarcador, idTransportadora, { fresco } = {}) {
  const { data } = await api.get(`/sftp-acesso/${idEmbarcador}/${idTransportadora}`, {
    params: fresco ? { fresco: "1" } : {},
  });
  return data;
}

export async function gerarNovaSenhaSftp(idEmbarcador, idTransportadora, { email } = {}) {
  const { data } = await api.post(`/sftp-acesso/${idEmbarcador}/${idTransportadora}/senha`, {
    email: email || undefined,
    confirmacao: true,
  });
  return data;
}

export async function mostrarSenhaSftp(idEmbarcador, idTransportadora) {
  const { data } = await api.get(`/sftp-acesso/${idEmbarcador}/${idTransportadora}/senha`);
  return data;
}

export async function incluirChaveSftp(idEmbarcador, idTransportadora, { nome, chavePublica }) {
  const { data } = await api.post(`/sftp-acesso/${idEmbarcador}/${idTransportadora}/chaves`, {
    nome,
    chavePublica,
  });
  return data;
}

export async function removerChaveSftp(idEmbarcador, idTransportadora, idChave) {
  const { data } = await api.delete(`/sftp-acesso/${idEmbarcador}/${idTransportadora}/chaves/${idChave}`);
  return data;
}

// Texto para o operador: `mensagem` (humano) > `error` (código) > fallback.
export function mensagemErro(err, fallback) {
  const d = err && err.response && err.response.data;
  if (d && typeof d.mensagem === "string" && d.mensagem) return d.mensagem;
  if (d && typeof d.error === "string" && d.error) return d.error;
  return fallback || "Falha ao falar com o servidor.";
}

export function codigoErro(err) {
  const d = err && err.response && err.response.data;
  return (d && d.error) || null;
}
